import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'types/state';

export const selectStatusFilter = createSelector(
  (state: GlobalState) => state.table,
  (filters) => filters.statusFilter,
);

export const selectTypeFilter = createSelector(
  (state: GlobalState) => state.table,
  (filters) => filters.typeFilter,
);

export const selectSelectedProduct = createSelector(
  (state: GlobalState) => state.table,
  (filters) => filters.selectedProduct,
);

export const selectTableItems = createSelector(
  (state: GlobalState) => state.table,
  (filters) => filters.tableItems,
);

export const selectISTableLoading = createSelector(
  (state: GlobalState) => state.table,
  (filters) => filters.isLoading,
);
